(function(){
  function init(rl){
    if(rl.dataset.mRlReady) return;
    rl.dataset.mRlReady = '1';
    var track = rl.querySelector('.m-rl__t');
    if(!track) return;
    var prev = rl.querySelector('.m-rl__nav--p');
    var next = rl.querySelector('.m-rl__nav--n');
    var bar = rl.querySelector('.m-rl__bar');
    var fill = bar ? bar.querySelector('i') : null;
    var anim = null;

    function max(){ return Math.max(track.scrollWidth - track.clientWidth, 0); }
    function tween(to){
      to = Math.max(0, Math.min(to, max()));
      var from = track.scrollLeft, d = to - from;
      if(anim) cancelAnimationFrame(anim);
      if(Math.abs(d) < 2){ track.scrollLeft = to; sync(); return; }
      var t0 = null, dur = 380;
      function step(ts){
        if(t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = from + d * e;
        sync();
        if(p < 1){ anim = requestAnimationFrame(step); } else { anim = null; }
      }
      anim = requestAnimationFrame(step);
    }
    function sync(){
      var m = max(), can = m > 4;
      if(prev){ prev.classList.toggle('is-on', can); prev.disabled = track.scrollLeft <= 2; }
      if(next){ next.classList.toggle('is-on', can); next.disabled = track.scrollLeft >= m - 2; }
      if(bar){
        bar.classList.toggle('is-on', can);
        if(fill && can){
          var vis = track.clientWidth / track.scrollWidth;
          fill.style.width = (vis * 100) + '%';
          fill.style.left = ((track.scrollLeft / track.scrollWidth) * 100) + '%';
        }
      }
    }
    function page(dir){ tween(track.scrollLeft + dir * track.clientWidth * 0.82); }

    if(prev) prev.addEventListener('click', function(){ page(-1); });
    if(next) next.addEventListener('click', function(){ page(1); });
    track.addEventListener('scroll', function(){ if(!anim) sync(); }, { passive: true });
    window.addEventListener('resize', sync);
    if(window.ResizeObserver){ new ResizeObserver(sync).observe(track); }
    sync();
    setTimeout(sync, 400);
  }
  function boot(){ document.querySelectorAll('.m-rl').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* Size chips on product cards: tap to choose the variant that "Add to bag" adds. */
(function(){
  function pick(btn){
    var card = btn.closest('.m-card'); if(!card || btn.dataset.soldout) return;
    card.querySelectorAll('.m-sizes__btn').forEach(function(b){ b.classList.remove('is-on'); b.setAttribute('aria-pressed','false'); });
    btn.classList.add('is-on'); btn.setAttribute('aria-pressed','true');
    var input = card.querySelector('.m-card__variant'); if(input) input.value = btn.dataset.variantId;
    var amt = card.querySelector('.m-card__amount'); if(amt && btn.dataset.price) amt.textContent = btn.dataset.price;
    var from = card.querySelector('.m-card__from'); if(from) from.style.display = 'none';
    var add = card.querySelector('.m-card__add'); if(add) add.setAttribute('aria-label', 'Add to bag - ' + (btn.dataset.title || btn.textContent.trim()));
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.m-sizes__btn'); if(btn){ e.preventDefault(); pick(btn); }
  });
})();
